
export default {
  props: {
    listings: {
      type: Array,
      default: () => [],
    },

    rows: {
      type: Number,
      default: 1,
    },

    slidesToShow: {
      type: Number,
      default: 1,
    },

    slidesPerRow: {
      type: Number,
      default: 5,
    },

    title: {
      type: String,
      default: 'Title',
    },

    pageInfo: {
      type: Object,
      default: null,
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      slickOptions: {
        infinite: false,

        responsive: [
          {
            breakpoint: 1496,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              slidesPerRow: 1,
              waitForAnimate: false,
            },
          },
          {
            breakpoint: 870,
            settings: {
              slidesToShow: 2.5,
              slidesToScroll: 1,
              touchThreshold: 3,
              slidesPerRow: 1,
              waitForAnimate: false,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              touchThreshold: 3,
              slidesPerRow: 1,
              waitForAnimate: false,
            },
          },
          {
            breakpoint: 632,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              touchThreshold: 5,
              slidesPerRow: 1,
              waitForAnimate: false,
            },
          },
          {
            breakpoint: 581,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              touchThreshold: 5,
              slidesPerRow: 1,
              waitForAnimate: false,
            },
          },
          {
            breakpoint: 426,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              touchThreshold: 5,
              slidesPerRow: 1,
              waitForAnimate: false,
            },
          },
          {
            breakpoint: 390,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              touchThreshold: 5,
              slidesPerRow: 1,
              waitForAnimate: false,
            },
          },
          {
            breakpoint: 305,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              touchThreshold: 5,
              slidesPerRow: 1,
              waitForAnimate: false,
            },
          },
        ],
      },
    }
  },

  computed: {
    sortedListings() {
      return this.listings
    },

    canGoPrevious() {
      if (!this.pageInfo) return false

      return this.pageInfo.currentPage > 1
    },

    canGoNext() {
      if (!this.pageInfo) return false

      return this.pageInfo.currentPage < this.pageInfo.pages
    },
  },

  watch: {
    listings() {
      this.$nextTick(() => {
        const slider = this.$refs[`slide${this.title}`]

        if (!slider) return

        slider.goTo(0)
      })
    },
  },

  methods: {
    showPrev() {
      if (!this.canGoPrevious || this.loading) {
        return
      }

      this.$emit('previous-page')
    },

    showNext() {
      if (!this.canGoNext || this.loading) {
        return
      }

      this.$emit('next-page')
    },
  },
}
